module.exports = __webpack_public_path__ + "media/images/360/weight_loss_bed-cd02dc21855d85cd29c57b546093bcea.webp";